export default __webpack_public_path__ + "static/media/camion_derecho.4535f9bc.png";